﻿import type { Download } from 'pages/courses/resources';
import type { Category, Product } from 'types';
import { ApiBase } from 'classes/ApiBase';

export class Api extends ApiBase {

    protected static baseUrl = '/Api/Resources';

    public static GetCategoriesWithProducts(userId: number): Promise<Category[]> {

	    return this.Post('GetCategoriesWithProducts', { userId }).then(res => res.json());

    }

    public static GetProductsWithResources(userId: number, productIds: string): Promise<Product[]> {

	    return this.Post('GetProductsWithResources', { productIds, userId }).then(res => res.json());

    }

    public static async DownloadResources(downloads: Download[]) {

	    const response = await this.Post('DownloadResources', { downloads });
	    const error = response.status === 500;
	    const errorReason = response.headers.get('Error-Reason');
	    const missingResources = response.headers.get('Missing-Resources');
	    let url = '';
	    if (!error) {

	        const blob = await response.blob();
	        url = window.URL.createObjectURL(blob);

	    }
	    return {
	        error,
	        errorReason,
	        missingResources,
	        url
	    };

    }

    public static async GetResourceDownloadsById(courseId: number, partnerId: number) {

	    return this.Post('GetResourceDownloadsById', { courseId, partnerId });

    }

}
